import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';

export const CREATABLE_WORKFLOW_ELEMENTS: ActionType[] = [
  ActionType.TAG,
  ActionType.OUTCOME,
];

export const defaultActionTypeOptions = {
  tag: {
    meta: {
      singleValueLabel: 'set tag',
      type: ActionType.TAG,
    },
  },
  'run a service': {
    meta: {
      singleValueLabel: 'run service',
      type: ActionType.SERVICE,
    },
  },
  'run a matrix': {
    meta: {
      singleValueLabel: 'run a Matrix:',
      type: ActionType.MATRIX_MODEL,
    },
  },
};
